import { Fragment } from 'react';
import PropTypes from 'prop-types';

import { leadTimeTitle } from '../messages/pdpBlurbMessages';

import styles from './PdpSharedLeadTime.scss';

import classnames from 'classnames';

export function PdpSharedLeadTime({ leadTime, valueClassName }) {
    return (
        <Fragment>
            <span>
                <span className={styles.label}>{leadTimeTitle}</span>
                <span
                    className={classnames(styles.value, valueClassName)}
                    data-tn="pdp-swatch-availability"
                >
                    {leadTime}
                </span>
            </span>
        </Fragment>
    );
}

PdpSharedLeadTime.propTypes = {
    leadTime: PropTypes.string,
    valueClassName: PropTypes.string,
};
